import gql from 'graphql-tag';

export default gql`
    query GetJobLogSummary($input: GetJobLogSummaryInput) {
        getJobLogSummary(input: $input) {
            wellName
            spillsCount
            logCountSummary {
                issue
                subCategory {
                    descrip
                    total
                }
            }
            logTimeSummary {
                issue
                subCategory {
                    descrip
                    total
                }
            }
            logTypesSummary {
                category
                totalCount
                totalTime
            }
            pivotData {
                jobLogTypeId
                jobLogType
                countonDate1
                countonDate2
                countonDate3
                countonDate4
                countonDate5
                countonDate6
                countonDate7
                countonDate8
                countonDate9
                countonDate10
                countonDate11
                countonDate12
                countonDate13
                countonDate14
            }
            stageStEndSummary {
                wellHead
                statsType
                statsonDate1
                statsonDate2
                statsonDate3
                statsonDate4
                statsonDate5
                statsonDate6
                statsonDate7
                statsonDate8
                statsonDate9
                statsonDate10
                statsonDate11
                statsonDate12
                statsonDate13
                statsonDate14
            }
        }
    }
`;
